import API from "Services/Api";

export const cancelOrder = async (order_id: number) => {
  try {
    const canceledOrder = await API.get(`/orders/cancel/${order_id}`)

    return canceledOrder.data

  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao cancelar o pedido";
  }

}